import classNames from 'classnames';
import { Link } from '@hc/redux-saga-router-plus';
import { TextButton } from 'legacy/components/Button';
import { NullStateCard } from '@hc/component-lib/hclib/components/molecules/null-state-card';

import { LocationUnknownWarning as theme } from 'legacy/css-modules';

const LocationUnknownWarning = ({
  showWarning,
  className,
  title,
  message,
  position,
  buttonLabel,
  buttonView,
  hideCTA
}) => {
  if (!showWarning) return null;
  return (
    <NullStateCard
      className={classNames(
        theme.LocationUnknownWarning,
        theme[position],
        className,
        {
          [theme.noMessage]: !message && hideCTA
        }
      )}
      title={title}
      theme={theme}
    >
      <div>{message}</div>
      {!hideCTA && (
        <Link view={buttonView} options={{ inherit: true }}>
          <TextButton primary>{buttonLabel}</TextButton>
        </Link>
      )}
    </NullStateCard>
  );
};

LocationUnknownWarning.defaultProps = {
  position: 'center',
  showWarning: false
};

export default LocationUnknownWarning;
